import Tags from 'collections/tags';

export default new Tags();
